import styled from 'styled-components';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import Btn from './Btn';

interface SearchOptionWrapProps {
  children: React.ReactNode;
  onSearch: () => void;
  onReset: () => void;
}

const SearchOptionWrap = ({
  children,
  onSearch,
  onReset,
}: SearchOptionWrapProps) => {
  return (
    <>
      <Wrap>
        <InputWrap>{children}</InputWrap>
        <BtnWrap>
          <Btn
            text="검색"
            colorType="type1"
            width="66px"
            height="32px"
            fontSize="13px"
            onClick={onSearch}
          />
          <Btn
            text="초기화"
            colorType="type2"
            width="66px"
            height="32px"
            fontSize="13px"
            onClick={onReset}
          />
        </BtnWrap>
      </Wrap>
    </>
  );
};

export default SearchOptionWrap;

const Wrap = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
`;

const InputWrap = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 40px;
`;

const BtnWrap = styled.div`
  display: flex;
  gap: 6px;
`;
